import { createContext, useState } from "react";

export const ParameterContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    let emptyParameter = {
        id: "",
        code: "",
        name: "",
        value: "",
        calculationUnit: "",
        enabled: true,
    };

    const [parameter, setParameter] = useState(emptyParameter);
    const [parameters, setParameters] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [parameterDialog, setParameterDialog] = useState(false);

    const resetParameter = () => {
        setParameter(emptyParameter);
    };

    // Make the context object:
    const parameterContext = {
        parameter,
        resetParameter,
        setParameter,
        parameters,
        setParameters,
        submitted,
        setSubmitted,
        parameterDialog,
        setParameterDialog,
    };

    // pass the value in provider and return
    return <ParameterContext.Provider value={parameterContext}>{children}</ParameterContext.Provider>;
};

export const { Consumer } = ParameterContext;
